export default __webpack_public_path__ + "86cddbb5a174f6e6055df4c43f4d75b0.png";